export default __webpack_public_path__ + "static/media/thumbnail-mobile-05.3ae2c7d1.png";